import React from 'react';
import { NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';

const ContactInfo = ({ onWebChatButtonClick, config }) => {
    var isChatBotEnabled = config && config.ChatBot_IsEnabled && config.ChatBot_IsEnabled.toLowerCase() === 'true';

    return (
        <>
            <NavItem
                eventKey={1}
                href="https://timepayment.com/equipment-financing/myaccount-manager"
                className="info-nav hidden"
                target="_blank"
                title="Visit Our FAQ"
            >
                <i className="fas fa-question-circle"></i>
                <span className="icon-text">FAQ</span>
            </NavItem>
            <NavItem className="info-nav-title">Support:</NavItem>
            {isChatBotEnabled ? (
                <NavItem
                    eventKey="webChat"
                    onClick={onWebChatButtonClick}
                    href="#"
                    className="info-nav"
                    title="Chat Now "
                >
                    <i className="fas fa-comment-smile"></i>
                    <span className="icon-text">Chat Now</span>
                </NavItem>
            ) : null}
            <NavItem eventKey={2} href="tel:877-868-3800" className="info-nav" title="Call Us: (877) 868-3800 ">
                <i className="fas fa-phone"></i>
                <span className="icon-text">(877) 868-3800</span>
            </NavItem>
            <NavItem
                eventKey={3}
                href="mailto:info@timepayment.com?cc=infohub@timepayment.com"
                className="info-nav"
                title="Email Us: info@timepayment.com"
            >
                <i className="fas fa-envelope"></i>
                <span className="icon-text">info@timepayment.com</span>
            </NavItem>
        </>
    );
};

// export default ContactInfo;
export default connect(
    (state) => ({
        config: state?.app?.config,
    }),
    null,
    null,
    { pure: false }
)(ContactInfo);
